var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement } from 'react';
import TrackKeys from './TrackKeys';
import setDefaultProperties from '../../../utils/setDefaultProperties';
import noop from '../../../utils/noop';
var DEFAULT_PROPS = {
    toggleOpen: noop,
};
export default function TrackKey(props) {
    var _a = setDefaultProperties(props, DEFAULT_PROPS), track = _a.track, toggleOpen = _a.toggleOpen;
    var title = track.title, tracks = track.tracks, isOpen = track.isOpen, sideComponent = track.sideComponent;
    return (_jsxs("li", __assign({ className: "rt-track-key" }, { children: [_jsxs("div", __assign({ className: "rt-track-key__entry" }, { children: [_jsx("span", __assign({ className: "rt-track-key__title" }, { children: title })), sideComponent ? cloneElement(sideComponent) : null] })), isOpen && tracks && tracks.length > 0 && _jsx(TrackKeys, { tracks: tracks, toggleOpen: toggleOpen })] })));
}
